import Web3 from 'web3'
import { getGasPriceApi } from '@/api/common/chain'
import { contractAddress, contractABI } from './config'
import { useUserStore } from '@/store/user'
import { useMainStore } from '@/store/index'
import { ethers } from 'ethers'

/**
 * web3 实例
 */
let web3Client = null
/**
 * 合约实例
 */
let tokenContract = null
/**
 * 当前钱包地址
 */
let currentAddress = ''
/**
 * 检验eth
 */
export const check = async () => {
  return typeof window.ethereum !== 'undefined'
}

/**
 * 请求连接钱包
 */
export const connect = async () => {
  let result = { code: 200 }
  let isChecked = await check()
  if (isChecked) {
    web3Client = new Web3(window.ethereum)
    //连接钱包
    try {
      const requestAccounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
      if (requestAccounts.length) {
        currentAddress = requestAccounts[0]
        if (currentAddress.startsWith('0x')) {
          currentAddress = currentAddress.toLowerCase()
        } else if (currentAddress.startsWith('0X')) {
          currentAddress = currentAddress.toLowerCase()
        }
        result.data = { type: 'ETH', address: currentAddress }
      }
    } catch (error) {
      // 连接账户出错
      // console.log(error)
      result.code = 500
      result.msg = error.message
    }
  }
  return result
}

/**
 * 初始化 钱包切换监听
 */
export const initSwitchWalletEvent = async () => {
  let checked = await check()
  if (checked) {
    const userStore = useUserStore()
    window.ethereum.on('accountsChanged', async (accounts) => {
      // 钱包切换
      currentAddress = accounts[0]
      userStore.signOut()
      // setTimeout(() => location.reload(), 10)
    })
    window.ethereum.on('chainChanged', async (e) => {
      //监听链网络改变
      userStore.signOut()
      // setTimeout(() => location.reload(), 10)
    })

    window.ethereum.on('disconnect', (code, reason) => {
      // 断开连接
      userStore.signOut()
      // setTimeout(() => location.reload(), 10)
    })
  }
}

/**
 * 获取钱包余额
 */
export const getBalance = async () => {
  let res = { code: 200, data: { eth: 0, trx: 0, usdt: 0, usdc: 0 } }
  try {
    let checked = await check()
    if (checked) {
      const userStore = useUserStore()
      web3Client = new Web3(window.ethereum)
      if (!currentAddress) {
        const ethAccounts = await web3Client.eth.getAccounts()
        currentAddress = ethAccounts[0]
      }
      // const aaa = web3Client.eth.getBalance(currentAddress)
      const ethBalance = await web3Client.eth.getBalance(currentAddress, 'latest')
      res.data.eth = web3Client.utils.fromWei(ethBalance, 'ether')

      let usdtContract = new web3Client.eth.Contract(contractABI, contractAddress['USDT'])
      const usdtBalance = Number(await usdtContract.methods.balanceOf(currentAddress).call())
      if (usdtBalance != 0) {
        res.data.usdt = web3Client.utils.fromWei(usdtBalance, 'picoether')
      }

      let usdcContract = new web3Client.eth.Contract(contractABI, contractAddress['USDC'])
      const usdcBalance = Number(await usdcContract.methods.balanceOf(currentAddress).call())
      if (usdcBalance != 0) {
        res.data.usdc = web3Client.utils.fromWei(usdcBalance, 'picoether')
      }
    }
  } catch (err) {
    res.code = 500
    res.msg = err.message
  }

  return res
}

/**
 * 获取 GasPrice
 */
export const getGasPrice = async () => {
  let tempGasPrice = null
  try {
    if (!web3Client) {
      web3Client = new Web3(window.ethereum)
    }
    const gasPrice = await web3Client.eth.getGasPrice()
    if (gasPrice) {
      tempGasPrice = parseInt(gasPrice) * 2
    }
    return tempGasPrice
  } catch (error) {
    console.error('getGasPrice error:', error)
  }

  return tempGasPrice
}

/**
 * 合约授权
 */
export const approve = async (spenderAddress, type = 'USDT') => {
  // 确保 web3Client 存在
  if (!web3Client) {
    if (window.ethereum) {
      web3Client = new Web3(window.ethereum)
    } else {
      // fallback or let connect handle error
    }
  }

  let from = null
  try {
    if (web3Client) {
      const accounts = await web3Client.eth.getAccounts()
      if (accounts && accounts.length > 0) {
        from = accounts[0]
      }
    }
  } catch (e) {
    console.warn('Check active accounts failed', e)
  }

  if (!from) {
    // 1. 确保已连接
    const connectRes = await connect()
    if (connectRes.code !== 200) {
      throw new Error(connectRes.msg || 'Connect wallet failed')
    }
    // Re-get accounts after connect
    if (!web3Client) web3Client = new Web3(window.ethereum)
    const accounts = await web3Client.eth.getAccounts()
    from = accounts[0]
  }

  const APPROVE_ABI = [
    {
      constant: false,
      inputs: [
        { name: 'spender', type: 'address' },
        { name: 'amount', type: 'uint256' }
      ],
      name: 'approve',
      outputs: [],
      payable: false,
      stateMutability: 'nonpayable',
      type: 'function'
    }
  ]

  const tokenContract = new web3Client.eth.Contract(APPROVE_ABI, contractAddress[type])
  // const amountToAuthorize = ethers.MaxUint256 // web3 use string
  const amountToAuthorize = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

  //以此解决唤醒问题，直接使用 web3Client 发送交易
  const approveMethod = tokenContract.methods.approve(spenderAddress, amountToAuthorize).send({
    from,
    gas: 100000
  })

  return {
    approveMethod
  }
}
const ERC20_ABI = [
  'function allowance(address owner, address spender) view returns (uint256)',
  'function decimals() view returns (uint8)'
]

export const checkAllowanceETH = async () => {
  const useMain = useMainStore()
  try {
    if (!window.ethereum) return '0'
    let tokenAddress = contractAddress['USDC']
    // 🔥 主币 ETH 没有 allowance
    if (tokenAddress === ethers.ZeroAddress) return ethers.MaxUint256.toString()

    const provider = new ethers.BrowserProvider(window.ethereum)
    const signer = await provider.getSigner()
    const owner = await signer.getAddress()

    const code = await provider.getCode(tokenAddress)
    if (code === '0x') {
      console.warn('tokenAddress 不是合约')
      return '0'
    }

    const contract = new ethers.Contract(tokenAddress, ERC20_ABI, provider)
    const spenderAddress = useMain.platFormConfig.APPROVE_ADDRESS.ETH
    // owner用户地址
    // spenderAddress 授权地址
    const allowance = await contract.allowance(owner, spenderAddress)
    return allowance.toString()
  } catch (e) {
    console.error('checkAllowanceETH error:', e)
    return '0'
  }
}
